import { render, staticRenderFns } from "./TenorSelect.vue?vue&type=template&id=24af4ad4&scoped=true&"
import script from "./TenorSelect.vue?vue&type=script&lang=js&"
export * from "./TenorSelect.vue?vue&type=script&lang=js&"
import style0 from "./TenorSelect.vue?vue&type=style&index=0&id=24af4ad4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24af4ad4",
  null
  
)

export default component.exports